import { render } from "./FeeDetailModal.vue?vue&type=template&id=cdb7b6a8"
import script from "./FeeDetailModal.vue?vue&type=script&lang=js"
export * from "./FeeDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__